import { t } from 'services/i18n'
import { MARKETPLACES } from 'constants/countries'

export const CI_MARKETS_LOCAL_STORAGE_KEY = 'competitiveIntelligence' // Store settings per market (object of market ids and their settings)
export const CI_GLOBAL_LOCAL_SOTRAGE_KEY = 'competitiveIntelligenceGlobal' // Store settings for CI feature globally

export const CI_SUPPORTED_MARKETPLACES = [MARKETPLACES.us]

export const CI_POSITION_TRACKING_HEATMAP_BOOL_KEY = 'ciPositionTrackingHeatmap'

export const MAX_ADD_ASINS_ALLOWED = 100

export const MAX_PINNED_PRODUCTS = 6

export const PRODUCTS_PAGE_SIZE = 25

export const MARKETS_PAGE_SIZE = 50

export const SUPPORTED_CATEGORY_KB_ARTICLE_LINK =
  'https://support.junglescout.com/hc/en-us/articles/25105595832727-Supported-and-Unsupported-Categories'

/**
 * The keys of this object should be determined by the number of pinned products.
 * Pinned products = Orange Hues
 * Unpinned products = Grey Hues
 */
export const GRAPH_COLOR_MAP = {
  0: ['grey800', 'grey700', 'grey600', 'grey500', 'grey400', 'grey300'],
  1: ['orange500', 'grey700', 'grey600', 'grey500', 'grey400', 'grey300'],
  2: ['orange700', 'orange500', 'grey600', 'grey500', 'grey400', 'grey300'],
  3: ['orange700', 'orange500', 'orange300', 'grey500', 'grey400', 'grey300'],
  4: ['orange700', 'orange500', 'orange400', 'orange300', 'grey400', 'grey300'],
  5: [
    'orange700',
    'orange600',
    'orange500',
    'orange400',
    'orange300',
    'grey300'
  ],
  6: [
    'orange900',
    'orange700',
    'orange600',
    'orange500',
    'orange400',
    'orange300'
  ]
}

export const MANUAL_SELECT = 'manual'
export const PRODUCTS_SELECT = 'products'
export const PRODUCT_SELECT_TYPES = [
  {
    content: t(
      'competitive_intelligence:CreateSegmentModal.selectType.manual',
      'Enter Manually'
    ),
    value: MANUAL_SELECT
  },
  {
    content: t(
      'competitive_intelligence:CreateSegmentModal.selectType.products',
      'Your Products'
    ),
    value: PRODUCTS_SELECT
  }
]

export const KEYWORD_ANALYSIS_HEATMAP_BOOL_KEY = 'keyword-analysis-heatmap'

export const SELECTOR_TOOLTIP_TYPES = {
  primary_product: t(
    'competitive_intelligence:ProductsSelector.selected.primaryProduct',
    'Product selected as the primary product'
  ),
  max_products: t(
    'competitive_intelligence:ProductsSelector.selected.maxProducts',
    'Max number of competitors selected'
  )
}

export const CHART_TOOLTIP_CONFIG = {
  width: 240,
  offset: 12, // space between tooltip and the cursor
  dotSize: 12
}

export const DATE_RANGE_OPTIONS = [
  {
    value: '1_months',
    content: t('generic:DateRangeOptions.1m', '1M')
  },
  {
    value: '3_months',
    content: t('generic:DateRangeOptions.3m', '3M')
  },
  {
    value: '6_months',
    content: t('generic:DateRangeOptions.6m', '6M')
  },
  {
    value: '12_months',
    content: t('generic:DateRangeOptions.12m', '12M')
  }
]

export const PRODUCT_SLIDEOUT_ATTRIBUTES = [
  'revenue',
  'units_sold',
  'avg_price',
  'star_rating',
  'reviews'
]

export const PRODUCT_SLIDEOUT_GRAPH_COLORS = {
  revenue: 'graphOrange',
  units_sold: 'graphBlue',
  avg_price: 'graphPurple',
  star_rating: 'graphRed',
  reviews: 'graphTeal'
}

export const PRODUCT_ACTIONS_KEYS = {
  productDetails: 'productDetails',
  viewKeywords: 'viewKeywords',
  analyzeReviews: 'analyzeReviews',
  viewOnAmazon: 'viewOnAmazon',
  copyAsin: 'copyAsin'
}

export const CI_INCENTIVE_UPGRADE_LINK = {
  suite:
    'https://members.junglescout.com/#/registrations?mt=142f1c00a369257fa0c8f594f68a0912&lang=en-US',
  pro:
    'https://members.junglescout.com/#/registrations?mt=7a6699ee64c4e3b38ddeb48388b7028a&lang=en-US'
}

export const CI_DEMO_SEGMENT_LOCAL_STORAGE_KEY = 'CI-Triggered-Demo-Segment'
